import { render, staticRenderFns } from "./taskContentItem.vue?vue&type=template&id=132e4f16&scoped=true"
import script from "./taskContentItem.vue?vue&type=script&lang=js"
export * from "./taskContentItem.vue?vue&type=script&lang=js"
import style0 from "../css/taskContentItem.styl?vue&type=style&index=0&id=132e4f16&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132e4f16",
  null
  
)

export default component.exports